import { AGENT_HUB_ADMIN_BASE_PATH } from '@lumapps/agent-hub/constants';
import { AppId, Route, createEntityManagementRoutes, createPageRoute } from '@lumapps/router';

const { baseRoute, createRoute, editRoute, getEditRoute } = createEntityManagementRoutes({
    slug: `${AGENT_HUB_ADMIN_BASE_PATH}/mcps`,
    id: 'agent-hub-mcps',
    appId: AppId.backOffice,
});

const MCPS_TOOLS_SLUG = `${AGENT_HUB_ADMIN_BASE_PATH}/mcps/tools/:toolProviderSlug`;

/** Route template used to match the tools page in a BrowserRoute. */
export const mcpsToolsAdminRoute: Route = createPageRoute({
    slug: MCPS_TOOLS_SLUG,
    appId: AppId.backOffice,
});

export const getMcpsEditRoute = (id: string): Route => getEditRoute(id);

export const getMcpsToolsRoute = (toolProviderSlug: string, serverName?: string): Route =>
    createPageRoute({
        slug: `${AGENT_HUB_ADMIN_BASE_PATH}/mcps/tools/${toolProviderSlug}`,
        appId: AppId.backOffice,
        query: serverName ? { name: serverName } : undefined,
    });

export { baseRoute as mcpsBaseAdminRoute, createRoute as mcpsCreateAdminRoute, editRoute as mcpsEditAdminRoute };
